module.exports = __webpack_public_path__ + "img/long-logo.ded1d3df.png";